/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */


jQuery.cookie = function(b, j, m) {
    if (typeof j != "undefined") {
        m = m || {};
        if (j === null) {
            j = "";
            m.expires = -1
        }
        var e = "";
        if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
            var f;
            if (typeof m.expires == "number") {
                f = new Date();
                f.setTime(f.getTime() + (m.expires * 24 * 60 * 60 * 1000))
            } else {
                f = m.expires
            }
            e = "; expires=" + f.toUTCString()
        }
        var l = m.path ? "; path=" + (m.path) : "";
        var g = m.domain ? "; domain=" + (m.domain) : "";
        var a = m.secure ? "; secure" : "";
        document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("")
    } else {
        var d = null;
        if (document.cookie && document.cookie != "") {
            var k = document.cookie.split(";");
            for (var h = 0; h < k.length; h++) {
                var c = jQuery.trim(k[h]);
                if (c.substring(0, b.length + 1) == (b + "=")) {
                    d = decodeURIComponent(c.substring(b.length + 1));
                    break
                }
            }
        }
        return d
    }
};

/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

window.Branch = window.Branch || {};
window.Branch.recentlyViewed = window.Branch.recentlyViewed || {};

// Turn a CDN image URL into the "files/<name>" form the recently-viewed cookie stores
// (readers prepend the CDN base themselves). Returns '' when the URL isn't a /files/ asset.
window.Branch.recentlyViewed.toCookieImagePath = function(url){
    const parts = (url || '').split('/files/');
    return parts[1] ? `files/${parts[1].split('?')[0]}` : '';
};

// What to store for one constituent of a pre-set bundle.
// Normally its static bundle.builder_image. But a constituent with no builder image is a
// composite product — its tile image is two layers picked per variant — so resolve that pair
// here (the bundle PDP carries its constituents' composite data) and store it as
// "<first>###<second>". Consumers that find a ### treat it as a layer stack; anything else
// stays a single flat image, so old cookies keep working.
window.Branch.recentlyViewed.returnConstituentRender = function(rvProduct, index){
    const staticRender = rvProduct[`product_${index}_render`] || '';
    const productId = rvProduct[`product_${index}_id`];
    const variantOptions = rvProduct[`product_${index}_variant_options`];
    const optionNames = rvProduct[`product_${index}_option_names`];
    const composite = window.Branch.compositeRenderImage;
    if (staticRender || !productId || !variantOptions || !composite || !composite.selectConstituentLayerPair) {
        return staticRender;
    }
    let layers = null;
    try {
        layers = composite.selectConstituentLayerPair({ options: variantOptions }, productId, optionNames);
    } catch (error) {
        console.error('Error resolving composite layers for bundle constituent:', error);
        return staticRender;
    }
    if (!layers) return staticRender;
    const first = window.Branch.recentlyViewed.toCookieImagePath(layers.first.url);
    const second = window.Branch.recentlyViewed.toCookieImagePath(layers.second.url);
    return (first && second) ? `${first}###${second}` : staticRender;
};

Shopify.Products = (function() {
    var a = {
        howManyToShow: 3,
        howManyToStoreInMemory: 5,
        wrapperId: "recently-viewed-products",
        templateId: "recently-viewed-product-template",
        onComplete: null
    };
    var c = [];
    var h = null;
    var d = null;
    var e = 0;
    var b = {
        configuration: {
            expires: 90,
            path: "/",
            domain: window.location.hostname
        },
        name: "shopify_recently_viewed",
        name1: "shopify_recently_viewed_data",
        write: function(i, index) {
            if(index == 0){
                jQuery.cookie(this.name, i.join(" "), this.configuration)
            } else {
                jQuery.cookie(this.name1, i.join(" "), this.configuration)
            }
        },
        read: function() {
            var i = [];
            var j = jQuery.cookie(this.name);
            var extraDataArray = [];
            var extraDataCookie = jQuery.cookie(this.name1);
            if (j !== null) {
                i = j.split(" ")
            }
            if (extraDataCookie !== null) {
                extraDataArray = extraDataCookie.split(" ")
            }
            return [i, extraDataArray]
        },
        destroy: function() {
            jQuery.cookie(this.name, null, this.configuration)
        },
        remove: function(k) {
            var j = this.read();
            var i = jQuery.inArray(k, j);
            if (i !== -1) {
                j.splice(i, 1);
                this.write(j)
            }
        }
    };
    var f = function() {
        h.show();
        if (a.onComplete) {
            try {
                a.onComplete()
            } catch (i) {}
        }
    };
    var g = function() {
        if (c.length && e < a.howManyToShow) {
            jQuery.ajax({
                dataType: "json",
                url: "/products/" + c[0] + ".js",
                cache: false,
                success: function(i) {
                    d.tmpl(i).appendTo(h);
                    c.shift();
                    e++;
                    g()
                },
                error: function() {
                    b.remove(c[0]);
                    c.shift();
                    g()
                }
            })
        } else {
            f()
        }
    };
    return {
        resizeImage: function(m, j) {
            if (j == null) {
                return m
            }
            if (j == "master") {
                return m.replace(/http(s)?:/, "")
            }
            var i = m.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i);
            if (i != null) {
                var k = m.split(i[0]);
                var l = i[0];
                return (k[0] + "_" + j + l).replace(/http(s)?:/, "")
            } else {
                return null
            }
        },
        showRecentlyViewed: function(i) {
            var i = i || {};
            jQuery.extend(a, i);
            c = b.read();
            d = jQuery("#" + a.templateId);
            h = jQuery("#" + a.wrapperId);
            a.howManyToShow = Math.min(c.length, a.howManyToShow);
            if (a.howManyToShow && d.length && h.length) {
                g()
            }
        },
        getConfig: function() {
            return a
        },
        clearList: function() {
            b.destroy()
        },
        recordRecentlyViewed: function(l) {
            var l = l || {};
            jQuery.extend(a, l);
            var j = b.read()[0];
            var extraDataCookieString = b.read()[1]
            if (window.location.pathname.indexOf("/products/") !== -1) {
                var k = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
                let rvProduct = JSON.parse(document.querySelector(`#recently-viewed-data`).innerText);

                // console.log('rvProduct', rvProduct, window.Branch.product._currentVariant);
                let compositeImages = [];
                if(window.Branch.product._currentVariant){
                    compositeImages = window.Branch.compositeRenderImage.returnRelevantCompositeImagesForVariant(window.Branch.product._currentProduct.variants[0], window.Branch.product._currentProduct.id, ['first_layer_images', 'second_layer_images'], window.Branch.product._currentProduct.options);
                    if(compositeImages.length > 0){
                        compositeImages = compositeImages.filter(img => img.dimensions_overlay_view === "front");
                    }
                }


                let rvString = `${rvProduct['handle']}@@${rvProduct['img_url']}@@${rvProduct['price']}@@${rvProduct['priceVaries']}@@${rvProduct['url']}@@${rvProduct['title']}@@${rvProduct['sale_text']}@@${rvProduct['variant_title']}@@${rvProduct['img_url_hover']}@@${rvProduct['color_combos']}@@${rvProduct['originalPrice']}|||`;
                if(rvProduct['preset_bundle'] == true){
                    let product1Render = window.Branch.recentlyViewed.returnConstituentRender(rvProduct, 1);
                    let product2Render = window.Branch.recentlyViewed.returnConstituentRender(rvProduct, 2);
                    rvString = `${rvProduct['handle']}@@${rvProduct['img_url']}@@${rvProduct['price']}@@${rvProduct['priceVaries']}@@${rvProduct['url']}@@${rvProduct['title']}@@${rvProduct['sale_text']}@@${rvProduct['variant_title']}@@${rvProduct['img_url_hover']}@@${rvProduct['color_combos']}@@${rvProduct['originalPrice']}@@true@@${product1Render}@@${product2Render}|||`;
                }
                if(compositeImages.length > 1){
                    rvString = `${rvProduct['handle']}@@${rvProduct['img_url']}@@${rvProduct['price']}@@${rvProduct['priceVaries']}@@${rvProduct['url']}@@${rvProduct['title']}@@${rvProduct['sale_text']}@@${rvProduct['variant_title']}@@${rvProduct['img_url_hover']}@@${rvProduct['color_combos']}@@${rvProduct['originalPrice']}@@false@@null@@null@@true@@files/${compositeImages[0].url.split('/files/')[1].split('?')[0]}@@files/${compositeImages[1].url.split('/files/')[1].split('?')[0]}@@|||`;
                }
                var i = jQuery.inArray(k, j);
                var extraDataCookiePosition= jQuery.inArray(rvString, extraDataCookieString);

                if (i === -1) {
                    j.unshift(k);
                    j = j.splice(0, a.howManyToStoreInMemory)
                } else {
                    j.splice(i, 1);
                    j.unshift(k)
                }
                if (extraDataCookiePosition === -1) {
                    extraDataCookieString.unshift(rvString);
                    extraDataCookieString = extraDataCookieString.splice(0, a.howManyToStoreInMemory)
                } else {
                    extraDataCookieString.splice(extraDataCookiePosition, 1);
                    extraDataCookieString.unshift(rvString)
                }
                b.write(j, 0)
                b.write(extraDataCookieString, 1)
            }
        }
    }
})();

Shopify.Products.recordRecentlyViewed();
